import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './Reviews.module.scss';

type SectionHeaderProps = {
  header: string | ReactNode;
  className?: string;
};

const SectionHeader = ({ header, className }: SectionHeaderProps) => {
  return <h3 className={classNames(styles.sectionHeader, className)}>{header}</h3>;
};

export default SectionHeader;
